<template>
    <q-layout view="hHh lpR fFf" style="height: 100vh">
        <q-page-container
            class="fit row wrap justify-center items-center content-center"
        >
            <q-card bordered style="width: 600px">
                <img
                    src="../assets/d_tr1.png"
                    style="width: 300px; height: 300px; margin: auto"
                />

                <q-card-section>
                    <q-input
                        v-model="mobileNumber"
                        label="Mobile Number"
                        outlined
                        style="width: 100%"
                    ></q-input>
                    <q-input
                        v-model="password"
                        label="Password"
                        outlined
                        type="password"
                        style="width: 100%; margin-top: 10px"
                    ></q-input>
                </q-card-section>

                <q-card-section class="fit row justify-center">
                    <p style="width: 100%; text-align: center">
                        New User? <a href="#/register">Register here</a>
                    </p>
                    <p style="width: 100%; text-align: center">
                        <a href="#/forgot-password">Forgot Password?</a>
                    </p>
                </q-card-section>

                <q-separator></q-separator>

                <q-card-actions>
                    <q-btn
                        label="Login"
                        color="indigo"
                        style="width: 120px"
                        @click="login"
                    ></q-btn>
                </q-card-actions>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<script>
import axios from "axios";
import { ref } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { Notify } from "quasar";

export default {
    setup() {
        const mobileNumber = ref();
        const password = ref();

        const router = useRouter();
        const login = async () => {
            try {
                const { data } = await axios.get(
                    "https://cycles.nlf.clinic/ws-nlp/public/pt-service/user-details",
                    {
                        params: {
                            mobileNumber: mobileNumber.value,
                            password: password.value,
                        },
                    }
                );
                localStorage.setItem("USER", JSON.stringify(data.userDetails));
                router.push({ name: "Home" });
            } catch (err) {

                Notify.create({
                        type: "negative",
                        message: "Wrong Mobile Number / Password",
                    });
            }
        };

        return {
            mobileNumber,
            password,
            login,
        };
    },
};
</script>

<style scoped>
.q-layout {
    background-image: url(../assets/d_nl.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
